var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01562 12.5482C7.61755 12.4027 8.23282 12.3295 8.85 12.3298C13.7375 12.3298 17.6984 16.8565 17.6984 22.4382C17.6984 28.0215 13.7375 32.5482 8.85 32.5482C3.9625 32.5482 0 28.0232 0 22.4382C0 22.2748 0.003125 22.1098 0.0109375 21.9465H0C0 13.5215 6 6.6665 13.375 6.6665V10.0598C10.9828 10.0598 8.77656 10.9898 7.01562 12.5482ZM26.8187 12.5482C27.4094 12.4048 28.0219 12.3298 28.65 12.3298C33.5375 12.3298 37.5 16.8565 37.5 22.4382C37.5 28.0215 33.5375 32.5482 28.65 32.5482C23.7625 32.5482 19.8016 28.0232 19.8016 22.4382C19.8016 22.2748 19.8047 22.1098 19.8125 21.9465H19.8016C19.8016 13.5215 25.8016 6.6665 33.1766 6.6665V10.0598C30.7828 10.0598 28.5797 10.9898 26.8187 12.5482Z",
    fill: "#4DBA43"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.77fba1861ad9539e587669e62e9dc73b.svg";
export { ForwardRef as ReactComponent };